import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=2506950c&"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts&"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports